import Bowser from 'bowser'

export const parseBrowser = () => Bowser.parse(window.navigator.userAgent)
